import { render } from "./Users-page.vue?vue&type=template&id=aa8857a8&scoped=true"
import script from "./Users-page.vue?vue&type=script&lang=js"
export * from "./Users-page.vue?vue&type=script&lang=js"

import "./style.scss?vue&type=style&index=0&id=aa8857a8&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa8857a8"]])

export default __exports__